// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientsOnkorallies_wrapper__h0mCX","title":"PatientsOnkorallies_title__qX0Zm"};